import apiClient from './apiClient';

// F90Q interface matching backend model
export interface F90Q {
  f90q_01: string;  // 科系名稱
  f90q_11: string;  // 備註/職務內容
  f90q_91: string;  // 建立人員代號
  f90q_92: string | null;  // 建立日期
  f90q_93: string;  // 最後修改人員代號
}

export interface ListResponse {
  data: F90Q[];
  total: number;
  page: number;
  size: number;
}

export interface ValidationError {
  field: string;
  code: string;
  message: string;
}

const BASE = '/api/dept-major';

const departmentMajorApi = {
  list: async (page = 1, size = 100, keyword?: string): Promise<ListResponse> => {
    if (keyword) {
      const res = await apiClient.get(`${BASE}/search`, { params: { keyword, page, size } });
      return res.data;
    }
    const res = await apiClient.get(BASE, { params: { page, size } });
    return res.data;
  },

  search: async (keyword: string, page = 1, size = 20): Promise<ListResponse> => {
    const res = await apiClient.get(`${BASE}/search`, { params: { keyword, page, size } });
    return res.data;
  },

  get: async (name: string): Promise<F90Q> => {
    const res = await apiClient.get(`${BASE}/${encodeURIComponent(name)}`);
    return res.data;
  },

  create: async (data: Partial<F90Q>): Promise<F90Q> => {
    const res = await apiClient.post(BASE, data);
    return res.data;
  },

  update: async (name: string, data: Partial<F90Q>): Promise<F90Q> => {
    const res = await apiClient.put(`${BASE}/${encodeURIComponent(name)}`, data);
    return res.data;
  },

  delete: async (name: string): Promise<void> => {
    await apiClient.delete(`${BASE}/${encodeURIComponent(name)}`);
  },
};

export default departmentMajorApi;
